import { ApiHttpClient } from "../../common/http/api-http-client";
import { ResourceBaseService } from "../../common/resource-base/resource-base.service";
import { WarehouseDto } from "@/core/features/warehouses/warehouse.dto";
import { CreateWarehouseDto } from "@/core/features/warehouses/create-warehouse.dto";
import { UpdateWarehouseDto } from "@/core/features/warehouses/update-warehouse.dto";
import { OptionType } from "@/types/OptionType";
import { IRequest } from "@/interfaces/IRequest";
import { merge } from "lodash";
import { HttpRequest } from "@/core/common/http/http-request";
import { applyOptionLoaderPagination } from "@/core/common/presenters/optionLoader";
import { FindManyResult } from "@/core/common/resource-base/find-many-result.dto";
import { plainToInstance } from "class-transformer";
import { LocationStockItemDto } from "@/core/features/locations/location-stock-item.dto";

export class WarehousesResource extends ResourceBaseService<WarehouseDto, CreateWarehouseDto, UpdateWarehouseDto> {
  protected EntityDto = WarehouseDto;
  protected CreateEntityDto = CreateWarehouseDto;
  protected UpdateEntityDto = UpdateWarehouseDto;

  constructor(protected readonly apiHttpClient: ApiHttpClient) {
    super(apiHttpClient, "/warehouses");
  }

  async optionLoader(inputValue: string, customRequest: IRequest = {}): Promise<OptionType[]> {
    const request: IRequest = inputValue ? { search: inputValue, searchBy: ["id", "name"] } : {};
    request.sortBy = "name";
    const { data } = await this.findAll(applyOptionLoaderPagination(merge(customRequest, request)));
    return data.map((value) => value.mapEntityToOptionType([value.name]));
  }

  async isDeletable(id: string): Promise<boolean> {
    return this.apiHttpClient
      .request(
        HttpRequest.create({
          url: this.resourceUrl + "/" + id + "/deletable",
          method: "GET",
          auth: true,
        })
      )
      .then((response) => response === "true");
  }

  getAvailableStock(warehouseId: string, customRequest: IRequest = {}): Promise<FindManyResult<LocationStockItemDto>> {
    const request = Object.assign({}, customRequest);
    return this.apiHttpClient
      .request<null, FindManyResult<LocationStockItemDto>>(
        HttpRequest.create({
          url: this.resourceUrl + "/" + warehouseId + "/available-stock",
          method: "GET",
          auth: true,
          query: this.getQueryBuilder(request).query(),
        })
      )
      .then((findManyResult) => {
        findManyResult.data = plainToInstance(LocationStockItemDto, findManyResult.data);
        return findManyResult;
      });
  }
}
